import axios from "@axios";
import * as ep from "./endpoints";
class AuthService {
  async login(payload) {
    return await axios
      .post(ep.LOGIN, payload)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  }

  async tempLogin(payload) {
    return await axios
      .post(ep.TEMP_LOGIN, payload)
      .then((res) => res.data)
      .catch((err) => err);
  }
  async ministryLogin(payload) {
    return await axios
      .post(ep.MINISTRY_LOGIN, payload)
      .then((res) => res.data)
      .catch((err) => err);
  }

  async logout() {
    const controller = new AbortController();
    controller.abort();
    return await axios.post(ep.LOGOUT).then((res) => res.data);
  }
  async ministryLogout() {
    const controller = new AbortController();
    controller.abort();
    return await axios.post(ep.MINISTRY_LOGOUT).then((res) => res.data);
  }
  async tempLogout() {
    const controller = new AbortController();
    controller.abort();
    return await axios.post(ep.TEMP_LOGOUT).then((res) => res.data);
  }
  async sliders() {
    return await axios.get(ep.SLIDERS).then((res) => res.data);
  }
}
const authService = new AuthService();
export default authService;
